import { render, staticRenderFns } from "./specialCardByNoHover.vue?vue&type=template&id=f4bd3c94"
import script from "./specialCardByNoHover.vue?vue&type=script&lang=js"
export * from "./specialCardByNoHover.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports